export type SingleImageFit = 'contain' | 'cover';

export enum RoundCornerType {
  CONTAINER = 'container',
  ITEM = 'item',
}
